import { PlanDTO, PlanDTOFromJSON } from '@atlassiansox/phobos-client-ts';

export const EMPTY_SYNC_PLAN: PlanDTO = { operations: [], hash: '', errors: [] };

// PlanDTOFromJSON throws on a missing `operations` field, so don't feed it an
// empty object while the plan is still loading.
export const toSyncPlan = (raw?: unknown): PlanDTO =>
  raw ? PlanDTOFromJSON(raw) : EMPTY_SYNC_PLAN;
